import React, { useContext, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grow,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import { AppContext } from '../../contexts/AppContext';
import { Bold } from '../../components/UI/TextFormatters';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import KeySVG from './KeySVG';

const passwordStyles = makeStyles(theme => ({
  label: {
    color: 'rgba(255, 255, 255, .5)',
    '&$focusedLabel': {
      color: 'rgba(255, 255, 255, .5)',
    },
  },
  focusedLabel: {},
  underline: {
    '&:after': {
      borderBottomColor: 'rgba(255, 255, 255, .5)',
    },
  },
}));

const PasswordInput = ({ fieldValue, setFieldValue }) => {
  const classes = passwordStyles();
  const [value, setValue] = useState(fieldValue);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ width: '100%' }}>
      <FormControl style={{ width: '100%' }}>
        <InputLabel
          classes={{
            root: classes.label,
            focused: classes.focusedLabel,
          }}
          htmlFor="standard-adornment-password">
          Contraseña
        </InputLabel>
        <Input
          autoComplete="new-password"
          classes={{
            root: classes.underline,
          }}
          style={{ color: 'white' }}
          id="standard-adornment-password"
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={event => setValue(event.target.value)}
          onBlur={() => setFieldValue(value)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                style={{ color: 'white' }}
                aria-label="Muestra/Oculta Contraseña"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={event => event.preventDefault()}>
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </div>
  );
};

const passPaperStyles = makeStyles(theme => ({
  keyIcon: {
    background: `radial-gradient(at bottom left, rgba(0,9,106,1) 0%, rgba(0,9,106,1) 100%)`,
    borderRadius: '30%',
    padding: '1.3em',
    fill: 'rgba(255,255,255,.6)',
    top: -20,
    right: -20,
    width: 70,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'rotate(45deg)',
    // top: 20,
    // right: 15,
    // width: 83,
    // position: 'absolute',
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // fill: 'rgba(255,255,255,.15)',
  },
  dialogPaper: {
    background: `radial-gradient(at bottom left,${theme.palette.primary.main} 0%, rgba(0,9,106,1) 80%)`,
  },
}));

const PassPaper = ({ children }) => {
  const classes = passPaperStyles();
  return (
    <div style={{ position: 'relative' }}>
      <div className={classes.keyIcon}>
        <KeySVG />
      </div>
      <Paper className={classes.dialogPaper}>{children}</Paper>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    '@supports (backdrop-filter: blur(10px))': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(10px)',
    },
  },
}));

const CreateUserPasswordModal = ({ open, setOpen, password, setPassword, onCancel, newUser }) => {
  const classes = useStyles();
  const { showWarning } = useContext(AppContext);

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = password.isBlank())) {
      errorMessages.push('Debe ingresar su contraseña');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const handleSave = () => {
    setOpen(false);
    newUser();
  };

  const validateAndSave = () => validate() && handleSave();

  return (
    <Dialog
      TransitionComponent={Grow}
      disableBackdropClick
      transitionDuration={500}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
      PaperComponent={PassPaper}
      maxWidth="sm"
      open={open}>
      <DialogContent>
        <div style={{ color: 'white' }}>
          <Typography variant="h6">
            <Bold>Autenticación</Bold>
          </Typography>
          <div style={{ marginTop: '.2em' }}>Se requiere su contraseña para la siguiente acción</div>
          <div style={{ margin: '1.5em 0 1em 0' }}>
            <PasswordInput fieldValue={password} setFieldValue={setPassword} />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button style={{ color: 'white' }} onClick={validateAndSave}>
          Aceptar
        </Button>
        <Button style={{ color: 'white' }} onClick={onCancel}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CreateUserPasswordModal;
